var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ButtonPrimary as Button } from './Button';
import Loader from './Loader';
import styled from 'styled-components';
import { clickedIds } from 'constants/analytics';
const StyledButton = styled(Button) `
  position: relative;
  overflow: hidden;
`;
const ProgressContainer = styled.div `
  position: 'absolute';
  margin-left: 'auto';
  margin-right: 'auto';
  left: 0;
  right: 0;
  opacity: 0;
  transform: translateY(30px);
  transition: transform 0.125s ease-in;
  display: flex;
  justify-content: center;
  align-items: center;

  & > * {
    color: ${({ theme }) => theme.palette.buttonText.primary};
  }

  ${({ visible }) => visible &&
    `
    opacity: 1;
    transform: translate(0);
  `}
`;
const Label = styled.span `
  ${({ visible }) => {
    let styles = {
        transition: 'all 0.125s ease-in',
        opacity: 1,
        transform: 'translateY(0)',
    };
    if (!visible) {
        styles = Object.assign(Object.assign({}, styles), { opacity: 0, transform: 'translateY(-30px)' });
    }
    return styles;
}}
`;
const LoadingButton = (_a) => {
    var { children, loading, disabled, onClick, type } = _a, rest = __rest(_a, ["children", "loading", "disabled", "onClick", "type"]);
    return (React.createElement(StyledButton, Object.assign({ type: type, onClick: onClick, disabled: loading || disabled }, rest),
        React.createElement(ProgressContainer, { visible: loading },
            React.createElement(Loader, null)),
        React.createElement(Label, { visible: !loading, "data-tracking-id": clickedIds.feedback }, children)));
};
export default LoadingButton;
